import { render, staticRenderFns } from "./upgradeModal.vue?vue&type=template&id=bc04f9fa&scoped=true"
import script from "./upgradeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./upgradeModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./upgradeModal.vue?vue&type=style&index=0&id=bc04f9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc04f9fa",
  null
  
)

export default component.exports